export const pad = (n) => String(n).padStart(2, "0");
const athensParts = () => Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Athens", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
}).formatToParts(new Date()).map((p) => [p.type, p.value]));
export const athensToday = () => { const p = athensParts(); return `${p.year}-${p.month}-${p.day}`; };
export const athensNowHHMM = () => { const p = athensParts(); return `${p.hour}:${p.minute}`; };
export const isoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const monthKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
export const parseIso = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const prettyDate = (s, locale = "en-GB") =>
  parseIso(s).toLocaleDateString(locale, { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export const priceLabel = (s, t = { free: "Free", minSpend: "min. spend" }) =>
  s.min_spend > 0 ? `${t.free} · ${t.minSpend} €${s.min_spend}` : s.price > 0 ? `€${s.price}` : t.free;

const utc = (s) => (s.endsWith("Z") ? s : `${s}Z`);
const icsStamp = (s) => new Date(utc(s)).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

export function downloadIcs(b) {
  const body = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//TAF Experience//Booking//EN", "BEGIN:VEVENT",
    `UID:${b.code}@tribebeachkos.gr`, `DTSTAMP:${icsStamp(b.created_at)}`,
    `DTSTART:${icsStamp(b.start_utc)}`, `DTEND:${icsStamp(b.end_utc)}`,
    `SUMMARY:${b.service_name} – Tribe Beach`, "LOCATION:Tribe Beach\\, Tigaki\\, Kos",
    `DESCRIPTION:Booking ${b.code}`, "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([body], { type: "text/calendar" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `tribe-${b.code}.ics`;
  a.click();
  URL.revokeObjectURL(url);
}

export const COUNTRY_CODES = [
  ["+30", "GR"], ["+44", "UK"], ["+49", "DE"], ["+43", "AT"], ["+41", "CH"], ["+39", "IT"],
  ["+33", "FR"], ["+31", "NL"], ["+32", "BE"], ["+48", "PL"], ["+46", "SE"], ["+47", "NO"],
  ["+45", "DK"], ["+358", "FI"], ["+353", "IE"], ["+34", "ES"], ["+351", "PT"], ["+420", "CZ"],
  ["+36", "HU"], ["+40", "RO"], ["+359", "BG"], ["+90", "TR"], ["+357", "CY"], ["+1", "US/CA"],
  ["+61", "AU"], ["+972", "IL"],
];
